import React, { useState } from 'react';
import axios from 'axios';
import { describeError } from '../../components/ErrorToast';
import { StepCard } from './VendorReportStep';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inp = 'w-full border border-slate-300 rounded px-2 py-1 text-[11px] bg-white';
const lbl = 'block text-[10px] uppercase font-bold text-slate-600 mb-0.5';
const COND = { GOOD: 'bg-emerald-100 text-emerald-800', DAMAGED: 'bg-rose-100 text-rose-800', INCOMPLETE: 'bg-amber-100 text-amber-800' };

function ReceiveForm({ shipment, onDone }) {
  const [f, setF] = useState({ received_date: new Date().toISOString().slice(0, 10), condition: 'GOOD', condition_notes: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true); setErr('');
    try {
      const { data } = await axios.post(`${API}/ha/couriers/${shipment.shipment_id}/receive`, { ...f, condition_notes: f.condition_notes || undefined });
      onDone(data);
    } catch (e) { setErr(describeError(e, 'Could not log receipt')); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 bg-slate-50 border border-slate-200 rounded p-2 space-y-2" data-testid={`inbound-receive-form-${shipment.shipment_id}`}>
      <div className="grid grid-cols-2 gap-2">
        <div><label className={lbl}>Received date *</label><input type="date" value={f.received_date} onChange={(e) => setF({ ...f, received_date: e.target.value })} data-testid="inbound-received-date" className={inp} /></div>
        <div><label className={lbl}>Condition on arrival *</label>
          <select value={f.condition} onChange={(e) => setF({ ...f, condition: e.target.value })} data-testid="inbound-condition" className={inp}>
            <option value="GOOD">Good</option><option value="DAMAGED">Damaged</option><option value="INCOMPLETE">Incomplete / parts missing</option>
          </select></div>
      </div>
      <div><label className={lbl}>Condition notes{f.condition !== 'GOOD' && ' *'}</label>
        <textarea rows={2} value={f.condition_notes} onChange={(e) => setF({ ...f, condition_notes: e.target.value })} placeholder="What is damaged or missing?" data-testid="inbound-condition-notes" className={inp} /></div>
      {f.condition !== 'GOOD' && <div className="text-[10.5px] text-amber-800" data-testid="inbound-hold-hint">The ticket will be flagged and held — it will not move to Ready for Pickup.</div>}
      {err && <div className="text-[11px] text-rose-700" data-testid="inbound-receive-error">{err}</div>}
      <div className="flex justify-end"><button onClick={submit} disabled={busy} data-testid="inbound-receive-submit" className="px-3 py-1 rounded bg-indigo-600 text-white text-[11px] font-bold disabled:opacity-50">{busy ? 'Saving…' : 'Log receipt'}</button></div>
    </div>
  );
}

export default function InboundReturnStep({ ticket, shipments, onChanged }) {
  const inbound = shipments.filter((s) => s.direction === 'INBOUND');
  const [open, setOpen] = useState(null);
  return (
    <StepCard n="C" title="Inbound return (vendor → clinic)" testid="step-inbound-return"
      hint={inbound.length === 0 ? 'Book the inbound courier in Couriers above' : null}>
      {ticket.arrival_issue && (
        <div className="mb-2 bg-rose-50 border border-rose-200 text-rose-800 rounded px-2 py-1.5 text-[11px]" data-testid="inbound-arrival-flag">
          <b>On hold:</b> arrived {String(ticket.inbound_condition || '').toLowerCase()} — {ticket.inbound_condition_notes}
        </div>
      )}
      {inbound.length === 0 ? <div className="italic text-slate-400 text-center" data-testid="inbound-empty">No inbound shipment yet.</div> : inbound.map((s) => (
        <div key={s.shipment_id} className="border-t first:border-t-0 border-slate-100 py-1.5" data-testid={`inbound-row-${s.shipment_id}`}>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono text-[10px]">{s.shipment_id}</span>
            <span>{s.courier_partner}</span>
            <span className="font-mono text-[10px]">{s.awb_number || <i className="text-amber-700">AWB pending</i>}</span>
            {s.received_date ? (
              <span className="ml-auto flex items-center gap-2" data-testid={`inbound-received-${s.shipment_id}`}>
                <span className="text-slate-600">Received {s.received_date}</span>
                {s.arrival_condition && <span className={`px-1.5 rounded text-[9.5px] font-bold ${COND[s.arrival_condition]}`}>{s.arrival_condition}</span>}
              </span>
            ) : s.status !== 'CANCELLED' && (
              <button onClick={() => setOpen(open === s.shipment_id ? null : s.shipment_id)} data-testid={`inbound-receive-toggle-${s.shipment_id}`} className="ml-auto text-[11px] font-semibold text-indigo-600 hover:underline">Mark received →</button>
            )}
          </div>
          {s.arrival_notes && <div className="text-[10.5px] italic text-slate-600 mt-0.5">{s.arrival_notes}</div>}
          {open === s.shipment_id && <ReceiveForm shipment={s} onDone={() => { setOpen(null); onChanged(); }} />}
        </div>
      ))}
    </StepCard>
  );
}
